/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".machine-template[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:14px;margin:10px 0 25px}"];
export { styles as styles };
